/* PAF HOME PRICE ALIGN V1 — featured product rows only. */
(() => {
  if (window.__pafHomePriceAlignV1) return;
  window.__pafHomePriceAlignV1 = true;
  let queued = false;
  function align() {
    queued = false;
    document.querySelectorAll('.paf-home-card-polish-v1 .section-grid.product-grid').forEach(grid => {
      const cards = Array.from(grid.children)
        .filter(li => li.matches('li.grid__item'))
        .map(li => {
          const card = li.querySelector('.product-card:not(.card--horizontal)');
          const title = card?.querySelector('.card__heading');
          const footer = card?.querySelector('.paf-card-price-footer');
          return title && footer && li.getClientRects().length ? {li, footer} : null;
        }).filter(Boolean);
      for (const item of cards) item.footer.style.removeProperty('--paf-price-row-offset');
      const rows = new Map();
      for (const item of cards) {
        const key = Math.round(item.li.getBoundingClientRect().top / 3) * 3;
        if (!rows.has(key)) rows.set(key, []);
        rows.get(key).push(item);
      }
      for (const row of rows.values()) {
        if (row.length < 2) continue;
        const measures = row.map(item => ({ item, top: item.footer.getBoundingClientRect().top }));
        const target = Math.max(...measures.map(m => m.top));
        for (const {item, top} of measures) {
          const extra = Math.max(0,target - top);
          if (extra > .5) item.footer.style.setProperty('--paf-price-row-offset', extra.toFixed(1)+'px');
        }
      }
    });
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(align);
  }
  function start() {
    schedule();
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('load', schedule, {once:true});
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts?.ready) document.fonts.ready.then(schedule);
    new MutationObserver(schedule).observe(document.querySelector('main') || document.body, {childList:true,subtree:true});
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();